<template>
  <div :class="['mini-video', playMode]" v-show="showPage" ref="playerWindow">
    <div class="mini-video-header" @mousedown="handleDragStart($event)">
      <label v-if="immediate">即时回放</label>
      <label v-else>{{ playMode == "live" ? "实时浏览" : "录像回放" }}</label>
      <el-tooltip class="item" effect="dark" content="关闭" placement="top-start">
        <i class="el-icon-close close-btn" @click="handleClose"></i>
      </el-tooltip>
    </div>
    <div class="mini-video-content">
      <div v-if="immediate" id="immediate" class="playWnd" ref="playBox"></div>
      <div v-else id="playWnd" class="playWnd" ref="playBox"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "YSPlayVideo", //宇视播放器
  props: {
    immediate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      playPlugin: this.$store.getters.playInfo, //播放器信息
      playBox: {
        immediate: "immediate",
        class: "playWnd",
        id: "",
      },
      playBoxDom: null, //播放器容器对象
      deviceInfo: {
        playId: "61010000001310000001",
        playTitle: "测试窗口",
      }, //设备信息
      showPage: false,
      isinitPlugin: false,
      playMode: "live", //播放模式,直播or录像
    };
  },
  mounted() {
    this.playBoxDom = document.querySelector(
      this.immediate ? "#" + this.playBox.immediate : "#" + this.playBox.class
    );
    // if (this.$store.getters.isInitPlay) {
    //   this.handleInitWnd();
    // } else {
    //   this.$app.AppInstance.handleInitPlay(() => {
    //     console.log("重新初始化成功");
    //     this.handleInitWnd();
    //   });
    // }
  },
  methods: {
    //拖拽
    handleDragStart(event) {
      const startX = event.clientX;
      const startY = event.clientY;
      const pw = this.$refs.playerWindow;
      const rectBox = pw.getBoundingClientRect();
      let moveX = 0;
      let moveY = 0;
      let flag = true;
      const moveEvent = (e) => {
        if (flag) {
          moveX = e.clientX - startX;
          moveY = e.clientY - startY;
          pw.style.left = rectBox.left + moveX + "px";
          pw.style.top = rectBox.top + moveY + "px";
          this.$nextTick(() => {
            // this.resizePlugin();
          });
        }
      };
      document.body.addEventListener("mousemove", moveEvent);
      const mouseUp = () => {
        flag = false;
        document.body.removeEventListener("mousemove", moveEvent);
        document.body.removeEventListener("mouseup", mouseUp);
      };
      document.body.addEventListener("mouseup", mouseUp);
    },
    // 显示播放窗口
    open(options) {
      this.showWnd(options);
    },
    // 开始构建播放器
    showWnd(options = this.deviceInfo) {
      this.deviceInfo = { ...options };
      this.playMode = options.playType;
      this.showPage = true;
      // if (this.playBox.id) {
      //   this.handleAddVideo();
      //   return;
      // }
      setTimeout(() => {
        this.handleAddVideo();
      }, 1000);
      // this.handleInitWnd();
    },

    // 初始化播放窗口
    handleInitWnd() {
      let iframeObj = imosSdk.createPanelWindow();
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        this.$message.warning("窗口创建已达最大数量，请关闭部分后创建");
        return;
      }
      this.playBoxDom.appendChild(iframeObj);
      this.playBox.id = iframeObj.id;
      // this.handleAddVideo();
    },

    // 播放视频
    handleAddVideo() {
      // console.log(this.playBox);
      console.log("播放信息", this.deviceInfo);
      imosSdk.delTitleBtn(this.playBox.id, "close");
      if (this.playMode == "live") {
        // 直播
        imosSdk.playLive(
          this.playBox.id,
          this.deviceInfo.playId, //"61010000001310000001",
          this.deviceInfo.playTitle,
          (res) => {
            console.log("播放回调", res);
            if (!this.immediate) {
              this.addBackVideoBtn(); //添加录像回放btn
              this.addAlarmBtn(); //添加上报告警btn
            }
          },
          1
        );
      } else {
        // 录像
        imosSdk.playRecord(
          this.playBox.id, //摄像机编码
          this.deviceInfo.playId, //"61010000001310000001", //
          this.deviceInfo.playTitle, //摄像机标题
          new Date(this.deviceInfo.startTime), //  new Date("2022-11-23 00:00:00"), // startTime 开始时间
          new Date(this.deviceInfo.endTime), //   new Date("2022-11-23 11:01:17") endTime 结束时间
          (res) => {
            this.addAlarmBtn(); //添加上报告警btn
            console.log("录像播放回调", res);
          },
          2
        );
      }
    },
    // 关闭播放
    handleClose() {
      if (!this.playBox.id) {
        this.showPage = false;
        return;
      }
      imosSdk.playStop(this.playBox.id, (res) => {
        this.showPage = false;
      });
    },
    // 添加控制栏按钮
    addBottomBtn(option) {
      let that = this;
      imosSdk.addBottomBtn(
        that.playBox.id, //窗口id
        option.buttonInfo,
        (res) => {
          option.clickFunc();
        }
      );
    },
    // 添加s上报告警btn
    addAlarmBtn() {
      let buttonInfo = {
        id: "videoAlarm",
        className: "videoAlarm videoBtn",
        tip: "上报告警",
      };
      this.addBottomBtn({
        buttonInfo: buttonInfo,
        clickFunc: this.handleAddAlarm,
      });
    },
    // 添加即时回放btn
    addBackVideoBtn() {
      let buttonInfo = {
        id: "videoBack",
        className: "videoBack videoBtn",
        tip: "即时回放",
      };
      this.addBottomBtn({
        buttonInfo: buttonInfo,
        clickFunc: this.handleImmediatePlay,
      });
    },
    //即时回放
    handleImmediatePlay() {
      this.$app.AppInstance.handleMiniPlayDialog({
        playType: "back",
        playTitle: this.deviceInfo.playTitle, //摄像机名称
        playId: this.deviceInfo.playId, //摄像机id
        startTime: new Date().getTime() - 1000 * 60 * 60 * 5, //如果没有时间默认最新一分钟
        endTime: new Date().getTime(),
      });
    },
    // 上报告警
    handleAddAlarm() {
      this.$app.AppInstance.handleMiniReportAlarm({
        name: this.deviceInfo.playTitle, //摄像机名称
        thirdCameraId: this.deviceInfo.playId, //摄像机id
        playRecordId: this.playBox.id, //窗口id
      });
    },
  },

  beforeDestroy() {
    console.log("1552");
  },
};
</script>

<style lang="scss" scoped>
:deep .imosSdk-video {
  width: 100% !important;
  height: 100% !important;
  border: none !important;
}
:deep .videoAlarm {
  background: url("/images/theme/newDark/play-box/上报告警.png") center no-repeat !important;
}
:deep .videoBack {
  background: url("/images/theme/newDark/play-box/即时回放.png") center no-repeat !important;
}
:deep .imosVideo-mask {
  background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat !important;
}
:deep .imosVideo-playPauseIcon {
  display: none !important;
}
.mini-video {
  font-size: 15px;
  user-select: none;
  display: flex;
  flex-direction: column;
  position: fixed;
  background-color: #000;
  border: #596f94 solid 0px;
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.6);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.6);
  left: 30%;
  top: 120px;
  padding: 0;
  z-index: 9999 !important;

  &.live {
    width: 600px;
    height: 400px;
  }
  &.back {
    width: 700px;
    height: 500px;
  }
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    background-color: #1c1f27;
    padding: 10px;
    cursor: move;

    .close-btn {
      color: #ffffff;
      cursor: pointer;
    }
  }

  &-content {
    flex: 1;
    height: 0;

    .playWnd,
    .immediate {
      height: 100%;
      width: 100%;
      padding: 0 10px 10px;
      background-color: #1c1f27;
      // background: #3a3a3a url("/images/theme/newDark/default.png") center
      //   no-repeat !important;
    }
  }
}
</style>
